import { DocumentUploadAccountTypes } from '@interfaces/models/doc-upload-types';

export function checkSelectedAccountsTypes(selectedAccountTypes: string[]): boolean {
  const hasValidLength = selectedAccountTypes.length > 0 && selectedAccountTypes.length <= 2;

  const allowedTypes = new Set<string>([
    DocumentUploadAccountTypes.IRA,
    DocumentUploadAccountTypes.INDIVIDUAL_JOINT_BROKERAGE,
  ]);

  return hasValidLength && selectedAccountTypes.every((type) => allowedTypes.has(type));
}
